import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { EmailDetailsModel } from "./models/email-details.model";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatChipsModule } from "@angular/material/chips";
import { MatTabsModule } from "@angular/material/tabs";
import { CerrixFieldWrapperComponent } from "@app/incident/components/src/lib/core/cerrix-field-wrapper/cerrix-field-wrapper.component";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/incident/i18n/scope";

@Component({
    selector: "sent-email-details",
    templateUrl: "./sent-email-details.component.html",
    styleUrls: ["./sent-email-details.component.scss"],
    imports: [CommonModule, MatChipsModule, MatTabsModule, CerrixFieldWrapperComponent, TranslatePipe],
    providers: [],
    viewProviders: [provideTranslationScope(scope)],
})
export class SentEmailDetailsComponent implements OnInit {
    @Input() public email: EmailDetailsModel;
    @Input() public dataUiid: string;

    protected embedHtml: SafeHtml;

    private readonly sanitizer = inject(DomSanitizer);

    ngOnInit(): void {
        this.embedHtml = this.sanitizer.bypassSecurityTrustHtml(this.email.body);
    }
}
